export const DETAIL_AI_RESULT_CACHE_DATA_COUNT = 200;
export const YOUTH_DETAIL_AI_RESULT_CACHE_DATA = 'YOUTH_DETAIL_AI_RESULT_CACHE_DATA';
export const SPOT_DETAIL_AI_RESULT_CACHE_DATA = 'SPOT_DETAIL_AI_RESULT_CACHE_DATA';
export const YOUTH_PK_DETAIL_AI_RESULT_CACHE_DATA = 'YOUTH_PK_DETAIL_AI_RESULT_CACHE_DATA';
export const AI_AUTH_KEY = '3ee86db3d9354c3fa9d3124142ac124';

export enum FromType {
  youthDetail = 1,
  youthPKDetail = 2,
  spotDetail = 3,
};

export const THINKING_STEPS = {
  [FromType.spotDetail]: [
    '正在扫描周边地理围栏数据...',
    '点位评分模型加载完成',
    '周边人口密度与流动性分析中...',
    '竞品分布与经营状态识别中...',
    '目标客群画像匹配中...',
  ],
  [FromType.youthDetail]: [
    '商圈基础评分加载完成',
    '商场业态结构分析中...',
    '客流量与峰值时段建模中...',
    '竞品入驻情况扫描完成',
    '消费客群画像生成中...',
  ],
  [FromType.youthPKDetail]: [
    '各商圈评分基线对齐完成',
    '人口覆盖与辐射范围计算中...',
    '竞品密度与市场饱和度评估中...',
    '客流量峰谷差异分析完成',
    '综合选址权重模型运算中...',
  ],
};

export const THINKING_FOOTER = {
  [FromType.spotDetail]: '数据整合完成，正在生成选址建议...',
  [FromType.youthDetail]: '多维度分析完成，正在输出商圈洞察...',
  [FromType.youthPKDetail]: '比对完成，正在推荐最优选址方案...',
};
